import { AboutUsContainer } from "../../containers";
import './style.scss'

function AboutUs() {
  return (
    <div id="aboutUs">
      <AboutUsContainer  />
    </div>
  );
}
export default AboutUs;
